import React from 'react';

function healthColor(percent) {
	if (percent > 50) return '#e85d75';
	if (percent > 25) return '#f5a623';
	return '#3ec97f';
}

export default function NotMovingPanel({ items, overallPercent }) {
	return (
		<div className="not-moving-panel">
			<div className="not-moving-panel__header">
				<span className="not-moving-panel__title">% Not Moving</span>
				<span
					className="not-moving-panel__overall"
					style={{ color: healthColor(overallPercent) }}
				>
					{overallPercent}%
				</span>
			</div>
			<div className="not-moving-panel__subtitle">Awaiting pickup</div>

			<div className="not-moving-panel__list">
				{items.length === 0 && (
					<div className="not-moving-panel__empty">No data</div>
				)}
				{items.map(item => (
					<div key={item.name} className="not-moving-row">
						<div className="not-moving-row__top">
							<span className="not-moving-row__name">{item.name}</span>
							<span
								className="not-moving-row__percent"
								style={{ color: healthColor(item.percent) }}
							>
								{item.percent === 0 ? '<1' : item.percent}%
							</span>
						</div>
						<div className="not-moving-row__track">
							<div
								className="not-moving-row__bar"
								style={{
									width: `${item.percent || 1}%`,
									background: healthColor(item.percent),
								}}
							/>
						</div>
						<div className="not-moving-row__count">{item.total.toLocaleString()} shipments</div>
					</div>
				))}
			</div>
		</div>
	);
}